import React from 'react';
import markdownContent from '!!raw-loader!static/privacy.md';
import { Markdown } from 'Common';

export const PrivacyPage = () => {
  return <Markdown>{markdownContent}</Markdown>;
};

export default PrivacyPage;
